import { initContract } from '@ts-rest/core';
import { defaultErrorResponses } from './errors';
import {
  SaveAttributionRequestSchema,
  SaveAttributionResponseSchema,
  UserAttributionResponseSchema,
} from '../schemas/attribution';

const c = initContract();

export const attributionContract = c.router({
  saveAttribution: {
    method: 'POST',
    path: '/v1/attribution',
    body: SaveAttributionRequestSchema,
    responses: {
      200: SaveAttributionResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Save user attribution data',
      description:
        'Records referral and UTM attribution for the authenticated user.',
    },
  },
  getAttribution: {
    method: 'GET',
    path: '/v1/attribution',
    responses: {
      200: UserAttributionResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Get user attribution data',
      description: 'Returns the recorded attribution parameters for the authenticated user.',
    },
  },
});
